<template>
  <div class="container would-get-vaccinated">
    <div class="row pt-2">
      <div class="col-12 offset-md-2 col-md-8">
        <vm-progress :percentage="38" :show-text="false" :stroke-width="12" :strokeColor="'#2bb1c4'"></vm-progress>
      </div>
    </div>
    <back-and-skip :hideSkip='true'>
    </back-and-skip>
    <div class="row pt-5 pt-lg-4">
      <div class="col-12 text-center">
        <img class="img-question" src="../assets/would_get_vaccinated.svg" alt="would-get-vaccinated">
      </div>
    </div>
    <div class="row row-title">
      <div class="col-12 offset-lg-2 col-lg-8 text-center text-wrap">
        <label class="title">
          {{ $t('wouldGetVaccinated.title') }}
        </label>
      </div>
    </div>
    <yes-no
      @yes="yes"
      @no="no">
    </yes-no>
  </div>
</template>

<script>
import BackAndSkip from '../components/BackAndSkip.vue'
import YesNo from '../components/YesNoButtons.vue'

export default {
  components: {
    BackAndSkip,
    YesNo
  },
  methods: {
    yes () {
      const answer = {
        key: 'would_you_get_treatment',
        value: 'yes'
      }

      this.$store.commit('SET_DATA_SURVEY', answer)

      this.$router.push({
        name: 'treatmentopengetting'
      })
    },
    no () {
      const answer = {
        key: 'would_you_get_treatment',
        value: 'no'
      }

      this.$store.commit('SET_DATA_SURVEY', answer)

      this.$router.push({
        name: 'concernedaboutvaccination'
      })
    }
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'wouldgetvaccinated')
  }
}
</script>

<style>
.would-get-vaccinated .img-question {
  width: 100%;
  height: 27vh;
}

.would-get-vaccinated .title {
  font-weight: 700;
  font-size: 1.4rem;
}

.would-get-vaccinated .row-title {
  padding-top: 2rem;
  padding-bottom: 4.5rem;
}

@media screen and (device-aspect-ratio: 40/71) {
  .would-get-vaccinated .img-question {
    width: 100%;
    height: 20vh;
  }

  .would-get-vaccinated .title {
    font-size: 1.1rem;
  }

  .would-get-vaccinated .row-title {
    padding-top: 2rem;
    padding-bottom: 2.5rem;
  }
}
</style>
